import {Box} from '@mui/material';
import {useState} from 'react';
import {useAuthUser} from '../../auth/hooks/useAuthUser';
import {VerifyEmailBanner} from '../../auth/VerifyEmailBanner';
import {PrivateSideNavigation} from '../../navigation/PrivateSideNavigation';
import {ComponentWithoutChildren} from '../../react/types';
import {useDeviceState} from '../../responsive/hooks/useDeviceState';
import {Content} from '../Content';
import {LayoutOffsetContext} from '../hooks/useLayoutOffset';
import {useOffsetHeight} from '../hooks/useOffsetHeight';
import {useOffsetWidth} from '../hooks/useOffsetWidth';
import {PrivateTopBar} from './PrivateTopBar';

export const PrivateLayout: ComponentWithoutChildren = () => {
  const {isNarrow} = useDeviceState();
  const authUser = useAuthUser();
  const verifyEmailBanner = !authUser.data.emailVerified && <VerifyEmailBanner />;

  /**
   * Dynamically compute the height/width of the major components.
   * These values will be used to align the components relative to each other in the layout.
   */
  const {offsetHeight: topBarHeight = 0, ref: topBarRef} = useOffsetHeight<HTMLDivElement>();
  const {offsetWidth: sideNavigationWidth = 0, ref: sideNavigationRef} = useOffsetWidth();
  const effectiveSideNavigationWidth = isNarrow ? 0 : sideNavigationWidth;

  const [narrowNavigationOpen, setNarrowNavigationOpen] = useState<boolean>(false);
  const toggleNarrowNavigationMenuOpen = () => setNarrowNavigationOpen(!narrowNavigationOpen);

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
      <LayoutOffsetContext value={{horizontalOffset: effectiveSideNavigationWidth, verticalOffset: topBarHeight}}>
        <PrivateTopBar handleNavigationMenuClick={toggleNarrowNavigationMenuOpen} ref={topBarRef} />
        <PrivateSideNavigation
          isNarrowNavigationOpen={narrowNavigationOpen}
          onNarrowNavigationClose={() => setNarrowNavigationOpen(false)}
          ref={sideNavigationRef}
        />
        <Content outletSx={{m: 2}} withAppInstallPrompt>
          {verifyEmailBanner}
        </Content>
      </LayoutOffsetContext>
    </Box>
  );
};

export default PrivateLayout; // Default export required for react lazy
